exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.spec-table[data-v-1d1e7677] {\n  width: 100%;\n}\n.list p[data-v-1d1e7677] {\n  min-height: 40px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.list[data-v-1d1e7677]:nth-child(2n) {\n  background: #f7f7f7;\n}\n", ""]);

// exports
